export const LegendItem = ({ text, color }) => {
  return (
    <div
      style={{
        width: 120,
        background: color,
        height: 30,
        fontSize: 16,
        textAlign: "center",
        lineHeight: "30px",
      }}
    >
      {text}
    </div>
  );
};
